<template>
  <div class="flex grow">
    <CopilotEditorSidebar
      v-if="isLoggedIn && isTabActive(`/${partner_slug}/website`)"
      :partner-slug="String(partner_slug)"
      class="hidden lg:flex"
    />

    <div class="flex min-w-0 grow flex-col border-t-4 border-brand">
      <div class="px-8 pt-4 md:px-10 md:pt-6 lg:pt-10">
        <Container>
          <div class="flex flex-col md:flex-row md:items-center md:gap-10 lg:gap-14">
            <img
              v-if="partner.logo"
              :src="partner.logo.thumb_url"
              :alt="partner.name"
              class="max-h-10 max-w-48 self-start object-contain object-left md:self-center"
            />

            <nav class="my-3 flex min-w-0 gap-4 overflow-x-auto sm:gap-6 md:my-0 lg:gap-8">
              <NuxtLink
                v-for="tab in tabs"
                :key="tab.to"
                :to="tab.to"
                class="shrink-0 whitespace-nowrap py-1.5 text-xs font-semibold uppercase tracking-wider transition-colors"
                :class="isTabActive(tab.to) ? 'text-brand' : 'text-gray-500 hover:text-brand'"
                :aria-current="isTabActive(tab.to) ? 'page' : undefined"
              >
                {{ tab.label }}
              </NuxtLink>
            </nav>
          </div>
        </Container>
      </div>

      <NuxtPage :partner="partner" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Partner } from '~/types/partner'
import type { LaravelModel } from '~/types/api'

const { partner_slug } = useRoute().params
const { data } = await useAsyncData(`partner-${partner_slug}`, () => $larafetch<LaravelModel<Partner>>(`/partners/${partner_slug}`))

if (!data.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found', fatal: true })
}

const partner = data.value.data

// Tabs
const { t } = useI18n()
const { isLoggedIn } = useAuth()
const route = useRoute()

const isTabActive = (to: string) => route.path === to || route.path.startsWith(`${to}/`)

const tabs = computed(() => [
  { to: `/${partner_slug}/experiences`, label: t('experiences') },
  // Always show the website tab when viewing it, so the page is never without an active tab
  ...(partner.display_copilot_page || isTabActive(`/${partner_slug}/website`) ? [{ to: `/${partner_slug}/website`, label: t('cobranded_website') }] : []),
  { to: `/${partner_slug}/about`, label: t('about') }
])

definePageMeta({
  hideNav: true
})
</script>
